<template>
  <div class="test-ui-container flex-column justify-content-center align-items-center">
    <div style="width: 80%;height: 40px;background-color: #0ba6fa;margin-top: 20px;border-radius: 10px"
         @click="jump('/rp/auth/init?key=AW001&token=')">
      <p style="line-height: 40px">12355</p>
    </div>
    <div style="width: 80%;height: 40px;background-color: #0ba6fa;margin-top: 20px;border-radius: 10px"
         @click="jump('/bjqn/auth/init?key=AW001&token=')">
      <p style="line-height: 40px">北疆青年云平台</p>
    </div>

    <div style="width: 80%;height: 40px;background-color: #0ba6fa;margin-top: 20px;border-radius: 10px"
         @click="jump('/exam/auth/init?key=AW001&token=')">
      <p style="line-height: 40px">答题</p>
    </div>
  </div>
</template>

<script>

import {getUser} from "@api/user";
import AES from "@/utils/AES.js";

export default {
  name: "test-ui",
  components: {},
  data() {
    return {
      route: {},
      userInfo: undefined
    }
  },
  created() {
    this.route = this.$route.query
    getUser().then(res => {
      console.log(res.data);
      try {
        this.userInfo = res.data;
      } catch (e) {
        this.toLoginMatch(true, "/match");
      }
    });
  },
  mounted() {

  },
  destroyed() {

  },
  methods: {
    jump(url) {

      var cars = {
        uid: 1,
        uuid: this.getUuid(),
        time: new Date().getTime()
      };
      var encrypts = AES.encrypt(JSON.stringify(cars));
      url += encrypts
      window.location = url;
    },
    getUuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0
        const v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      }).replaceAll("-", "")
    }
  }
}
</script>

<style scoped>

@import "../../assets/css/flex.css";

.test-ui-container {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
